module.exports = __webpack_public_path__ + "files/570fd0ecd8ed47f6dea07dc8f1e4e11d.svg";